import { render, staticRenderFns } from "./attribution.vue?vue&type=template&id=35815991&scoped=true"
import script from "./attribution.vue?vue&type=script&lang=js"
export * from "./attribution.vue?vue&type=script&lang=js"
import style0 from "./attribution.vue?vue&type=style&index=0&id=35815991&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35815991",
  null
  
)

export default component.exports